/* eslint-disable no-console */
import { Logtail } from '@logtail/browser';
// eslint-disable-next-line import/no-cycle
import { getShop } from './pageData';
// eslint-disable-next-line import/no-cycle
import { getOrderID } from './settings';
import { getLogtailEndpoint, getLogtailKey } from '../config';

export type ServerErrorLogMetaDataType = {
  fileName: string;
  functionName: string;
  lineNumber: string;
  columnNumber: string;
  level: string | number;
  extraErrorData?: any;
  extraInfoData?: any;
  bundleName: string;
  errorStack?: Error;
  error?: Error;
};

const logtailKey = getLogtailKey();
const logtailEndpoint = getLogtailEndpoint();
let tempLogtail = null;
if (logtailKey && logtailEndpoint) {
  tempLogtail = new Logtail(logtailKey, {
    endpoint: logtailEndpoint,
  });

  const enrichLogs = async log => ({
    ...log,
    mrOrderId: getOrderID(),
    shop: getShop(),
  });

  if (tempLogtail) tempLogtail.use(enrichLogs);
}

const logtail = tempLogtail;

export const logger = {
  log: (...data: any[]) => {
    if (localStorage.getItem('mr-debug')) {
      console.log(...data);
    }
  },
  Debug: (...data: any[]) => {
    if (localStorage.getItem('mr-debug')) {
      console.log('[DEBUG]', data);
    }
  },
  serverInfoLog: (message: string, metadata: ServerErrorLogMetaDataType) => {
    if (logtail) {
      logtail.info(message, metadata);
      logtail.flush();
    }
  },
  serverErrorLog: (message: string, metadata: ServerErrorLogMetaDataType) => {
    if (logtail) {
      logtail.error(message, metadata);
      logtail.flush();
    }
  },
};

export { logtail };
